import request from './common/request'
import qs from 'qs'
import axios from 'axios'
import store from '@/store'

import {
  MERCHANT_SMS_SIGN_URI,
  MERCHANT_SMS_TEMPLATE_URI,
  MERCHANT_SMS_CONTACT_URI,
  MERCHANT_SMS_MESSAGE_URI,
  MERCHANT_SMS_PACKAGE_URI,
  MERCHANT_SMS_CONTACT_GROUP_URI,
  MERCHANT_SMS_GOODS_URI
} from './urls'

// 获取签名模版列表
async function listSigns (query) {
  return request(
    {
      url: MERCHANT_SMS_SIGN_URI,
      method: 'GET',
      params: query
    }
  )
}

async function allSigns (query) {
  return request(
    {
      url: `${MERCHANT_SMS_SIGN_URI}/all`,
      method: 'GET',
      params: query
    }
  )
}

async function getSignById (id) {
  return request(
    {
      url: `${MERCHANT_SMS_SIGN_URI}/${id}`,
      method: 'GET'
    }
  )
}

async function addSign (data) {
  return request(
    {
      url: `${MERCHANT_SMS_SIGN_URI}`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateSign (data) {
  return request(
    {
      url: `${MERCHANT_SMS_SIGN_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function submitAuditSign (id) {
  return request(
    {
      url: `${MERCHANT_SMS_SIGN_URI}/${id}/audit`,
      method: 'PUT'
    }
  )
}

async function cancelAuditSign (id) {
  return request(
    {
      url: `${MERCHANT_SMS_SIGN_URI}/${id}/cancel`,
      method: 'PUT'
    }
  )
}

async function listTemplates (query) {
  return request(
    {
      url: MERCHANT_SMS_TEMPLATE_URI,
      method: 'GET',
      params: query
    }
  )
}

async function getTemplateById (id) {
  return request(
    {
      url: `${MERCHANT_SMS_TEMPLATE_URI}/${id}`,
      method: 'GET'
    }
  )
}

async function addTemplate (data) {
  return request(
    {
      url: `${MERCHANT_SMS_TEMPLATE_URI}`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateTemplate (data) {
  return request(
    {
      url: `${MERCHANT_SMS_TEMPLATE_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function submitAuditTemplate (id) {
  return request(
    {
      url: `${MERCHANT_SMS_TEMPLATE_URI}/${id}/audit`,
      method: 'PUT'
    }
  )
}

async function cancelAuditTemplate (id) {
  return request(
    {
      url: `${MERCHANT_SMS_TEMPLATE_URI}/${id}/cancel`,
      method: 'PUT'
    }
  )
}

async function listContacts (query) {
  return request(
    {
      url: MERCHANT_SMS_CONTACT_URI,
      method: 'GET',
      params: query
    }
  )
}

async function allContacts (query) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_URI}/all`,
      method: 'GET',
      params: query
    }
  )
}

async function getContactById (id) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_URI}/${id}`,
      method: 'GET'
    }
  )
}

async function addContact (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_URI}`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateContact (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function removeContact (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_URI}/${data.id}`,
      method: 'DELETE'
    }
  )
}

async function uploadContacts (forms) {
  const result = await axios.post(`${process.env.BASE_API}${MERCHANT_SMS_CONTACT_URI}/upload`, forms,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${store.state.MerchantAuth.accessToken}`
      }
    }
  )
  return result
}

async function uploadSimpleContacts (forms) {
  const result = await axios.post(`${process.env.BASE_API}${MERCHANT_SMS_MESSAGE_URI}/upload`, forms,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${store.state.MerchantAuth.accessToken}`
      }
    }
  )
  return result
}

async function listContactGroups (query) {
  return request(
    {
      url: MERCHANT_SMS_CONTACT_GROUP_URI,
      method: 'GET',
      params: query
    }
  )
}

async function allContactGroups (query) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}/all`,
      method: 'GET',
      params: query
    }
  )
}

async function getContactGroupById (id) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}/${id}`,
      method: 'GET'
    }
  )
}

async function addContactGroup (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function updateContactGroup (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

async function removeContactGroup (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}/${data.id}`,
      method: 'DELETE'
    }
  )
}

async function addContactsToContactGroup (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}/${data.id}/contacts`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function removeContactFromContactGroup (data) {
  return request(
    {
      url: `${MERCHANT_SMS_CONTACT_GROUP_URI}/${data.id}/contacts/${data.contactId}`,
      method: 'DELETE'
    }
  )
}

async function sendMessage (data) {
  return request(
    {
      url: `${MERCHANT_SMS_MESSAGE_URI}/send`,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

async function listMessages (query) {
  return request(
    {
      url: MERCHANT_SMS_MESSAGE_URI,
      method: 'GET',
      params: query
    }
  )
}

async function listPackages (query) {
  return request(
    {
      url: MERCHANT_SMS_PACKAGE_URI,
      method: 'GET',
      params: query
    }
  )
}

async function listGoods (query) {
  return request(
    {
      url: MERCHANT_SMS_GOODS_URI,
      method: 'GET',
      params: query
    }
  )
}

async function getPaymentUrl (data) {
  return request(
    {
      url: `${MERCHANT_SMS_GOODS_URI}/${data.goodsId}/buy/${data.payType}`,
      method: 'GET'
    }
  )
}

export default {
  listSigns,
  allSigns,
  getSignById,
  addSign,
  updateSign,
  submitAuditSign,
  cancelAuditSign,
  listTemplates,
  getTemplateById,
  addTemplate,
  updateTemplate,
  submitAuditTemplate,
  cancelAuditTemplate,
  listContacts,
  allContacts,
  getContactById,
  addContact,
  updateContact,
  removeContact,
  uploadContacts,
  uploadSimpleContacts,
  listContactGroups,
  allContactGroups,
  getContactGroupById,
  addContactGroup,
  updateContactGroup,
  removeContactGroup,
  addContactsToContactGroup,
  removeContactFromContactGroup,
  sendMessage,
  listMessages,
  listPackages,
  listGoods,
  getPaymentUrl
}



// WEBPACK FOOTER //
// ./src/api/merchant-sms.js